import { useState, useEffect } from "react";
import { FiDownload } from "react-icons/fi";
import ZolaLogo from "../../HQDashboard/components/sidebar/Layer_1.png";
import QRCode from "qrcode";
import axios from "axios";

function QRCodeModal({ showModal, setShowModal, companyUrl }) {
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  // Fetch company profile image
  useEffect(() => {
    const fetchCompanyProfile = async () => {
      try {
        const token = localStorage.getItem("token"); // or sessionStorage, depending on your setup
        const response = await axios.get(
          "https://zola.technology/api/company/profile/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data;
        setProfileImage(data.profile_image || null);
      } catch (error) {
        console.error("Failed to fetch company profile:", error);
      } finally {
        setLoadingProfile(false);
      }
    };

    if (showModal) {
      fetchCompanyProfile();
    }
  }, [showModal]);

  // Generate QR code
  useEffect(() => {
    if (companyUrl) {
      QRCode.toDataURL(companyUrl, {
        errorCorrectionLevel: "H",
        width: 192,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff",
        },
      }).then(setQrCodeUrl);
    }
  }, [companyUrl]);

  const handleDownload = async () => {
    const qrSize = 192;
    const textHeight = 60;
    const padding = 20;

    const totalWidth = qrSize + padding * 2;
    const totalHeight = qrSize + textHeight + padding * 3;

    const canvas = document.createElement("canvas");
    canvas.width = totalWidth;
    canvas.height = totalHeight;
    const ctx = canvas.getContext("2d");

    // Fill background white
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, totalWidth, totalHeight);

    // Draw text
    ctx.fillStyle = "#FF0000";
    ctx.font = "bold 20px sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("SCAN THE QR CODE", totalWidth / 2, padding + 20);

    ctx.fillStyle = "#0C0C3F";
    ctx.font = "16px sans-serif";
    ctx.fillText("RATE YOUR EXPERIENCE", totalWidth / 2, padding + 45);

    // Load QR code image
    const qrImg = new Image();
    qrImg.crossOrigin = "anonymous";
    qrImg.src = qrCodeUrl;

    qrImg.onload = () => {
      // Draw QR code
      ctx.drawImage(qrImg, padding, textHeight + padding, qrSize, qrSize);

      // Load logo
      const logoSize = qrSize / 3;
      const centerX = padding + qrSize / 2;
      const centerY = textHeight + padding + qrSize / 2;

      const logoImg = new Image();
      logoImg.crossOrigin = "anonymous";
      logoImg.src = profileImage || ZolaLogo;

      logoImg.onload = () => {
        // Clip circle
        ctx.save();
        ctx.beginPath();
        ctx.arc(centerX, centerY, logoSize / 2, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.clip();

        ctx.drawImage(
          logoImg,
          centerX - logoSize / 2,
          centerY - logoSize / 2,
          logoSize,
          logoSize
        );

        ctx.restore();

        // Trigger download
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "company-qr-with-text.png";
        link.click();
      };
    };
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-lg w-96 grid">
        <div className="flex flex-col items-center">
          <h2 className="text-[#FF0000] text-center font-semibold text-2xl">
            SCAN THE QR CODE
          </h2>
          <h3 className="text-[#0C0C3F] text-center text-lg">
            RATE YOUR EXPERIENCE
          </h3>
        </div>

        {qrCodeUrl && !loadingProfile ? (
          <div className="flex flex-col items-center">
            <div className="flex flex-col items-center mb-4">
              <div className="relative w-48 h-48">
                <img
                  src={qrCodeUrl}
                  alt="Company QR Code"
                  className="w-48 h-48 z-20 rounded-lg shadow-lg"
                />
                <img
                  src={profileImage || ZolaLogo}
                  alt="Company Logo"
                  className="absolute top-1/2 left-1/2 w-16 h-16 object-cover rounded-full border-2 border-white shadow-md transform -translate-x-1/2 -translate-y-1/2 z-10"
                />
              </div>
            </div>

            <button
              onClick={handleDownload}
              className="px-4 py-2 w-full bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition duration-300 flex items-center justify-center gap-2"
            >
              <FiDownload />
              Download QR Code
            </button>
          </div>
        ) : (
          <p className="text-gray-500 dark:text-gray-400">
            Generating QR Code...
          </p>
        )}

        <button
          onClick={() => setShowModal(false)}
          className="mt-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default QRCodeModal;
